module.exports = __webpack_public_path__ + "img/swipe2-icon-active.71dfcb91.png";